<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="ui-module-titlebar font-weight-bold justify-center">Catálogo de armas</v-card-title>
          <v-card-text>
            <v-container fluid>
              <v-row align="center" no-gutters class="mb-4">
                <v-col cols="auto" class="mr-4">
                  <div class="text-caption font-weight-bold mb-2">Tipo</div>
                  <v-btn-toggle v-model="filtroTipoArma" mandatory rounded>
                    <v-btn small value="TODOS">Todos</v-btn>
                    <v-btn small value="CORTA">Corta</v-btn>
                    <v-btn small value="LARGA">Larga</v-btn>
                  </v-btn-toggle>
                </v-col>
                <v-col class="mr-4">
                  <v-select
                    v-model="marcasSeleccionadas"
                    :items="marcasDisponibles"
                    multiple
                    clearable
                    chips
                    small-chips
                    rounded
                    filled
                    dense
                    hide-details
                    background-color="transparent"
                    color="secondary"
                    item-color="secondary"
                    class="filter-input"
                    label="Marca"
                  ></v-select>
                </v-col>
                <v-col class="mr-4">
                  <v-select
                    v-model="estatusSeleccionados"
                    :items="estatusDisponibles"
                    multiple
                    clearable
                    chips
                    small-chips
                    rounded
                    filled
                    dense
                    hide-details
                    background-color="transparent"
                    color="secondary"
                    item-color="secondary"
                    class="filter-input"
                    label="Estatus"
                  ></v-select>
                </v-col>
                <v-col class="d-flex align-center">
                  <v-text-field
                    v-model="buscaArma"
                    rounded
                    filled
                    dense
                    hide-details
                    background-color="transparent"
                    color="secondary"
                    label="Buscar"
                    append-icon="mdi-magnify"
                    class="search-input flex-grow-1"
                  ></v-text-field>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" class="ml-2">
                        <IconButton variant="secondary" icon="mdi-plus" @click="openRegistroArmaDialog" />
                      </span>
                    </template>
                    <span>Registrar arma nueva</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" class="ml-2">
                        <IconButton variant="secondary" icon="mdi-refresh" @click="fetchArmas" />
                      </span>
                    </template>
                    <span>Actualizar tabla</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" class="ml-2">
                        <IconButton variant="secondary" icon="mdi-download" @click="descargarCsv" />
                      </span>
                    </template>
                    <span>Descargar CSV</span>
                  </v-tooltip>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <EstadisticasInventarioArmas :armas="armasFiltradas" />
                </v-col>

                <v-col cols="12">
                  <v-data-table class="primary" :headers="headers" :items="armasFiltradas" calculate-widths>
                    <template v-slot:[`item.estatus`]="{ item }">
                      <span class="text-body-2">{{ item.CatEstatus.title }}</span>
                    </template>
                    <template v-slot:[`item.opciones`]="{ item }">
                      <span class="d-flex align-center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <IconButton
                                class="mr-2"
                                variant="secondary"
                                icon="mdi-update"
                                @click="openEstatusArmaDialog(item)"
                              />
                            </span>
                          </template>
                          <span>Estatus arma</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <IconButton
                                class="mr-2"
                                variant="secondary"
                                icon="mdi-pencil"
                                :loading="loadingEditarArma === item.idArma"
                                @click="openEditarArmaDialog(item)"
                              />
                            </span>
                          </template>
                          <span>Editar arma</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <IconButton
                                variant="secondary"
                                icon="mdi-history"
                                @click="openHistorialArmasDialog(item)"
                              />
                            </span>
                          </template>
                          <span>Historial armas</span>
                        </v-tooltip>
                      </span>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { DIALOG_TYPES } from '../../../../plugins/dialog-types'
import IconButton from '../../../base/IconButton.vue'
import EstadisticasInventarioArmas from './EstadisticasInventarioArmas.vue'
import downloadCsv from '@/utils/downloadCsv'

export default {
  components: {
    IconButton,
    EstadisticasInventarioArmas,
  },

  data() {
    return {
      headers: [
        { text: 'Tipo', value: 'CatClase.CatTipo.title', width: '10%' },
        { text: 'Marca', value: 'CatModelo.CatMarca.title', width: '10%' },
        { text: 'Modelo', value: 'CatModelo.modelo', width: '5%' },
        { text: 'Folio', value: 'folio', width: '10%' },
        { text: 'Matrícula', value: 'matricula', width: '10%' },
        { text: 'No. económico', value: 'noEconomico', width: '10%' },
        { text: 'Armero', value: 'armeros', width: '10%' },
        { text: 'Fecha alta LOC', value: 'fechaAltaLoc', width: '10%' },
        { text: 'Estatus', value: 'estatus', width: '15%', sortable: false },
        { text: 'Opciones', value: 'opciones', align: 'right', sortable: false },
      ],
      selectedArma: null,
      loadingEditarArma: false,
      filtroTipoArma: 'TODOS',
      marcasSeleccionadas: [],
      estatusSeleccionados: [],
      buscaArma: '',
      DIALOG_TYPES,
    }
  },

  computed: {
    ...mapGetters('arma', {
      armas: 'getArmas',
    }),
    marcasDisponibles() {
      return [...new Set((this.armas || []).map((arma) => arma?.CatModelo?.CatMarca?.title).filter(Boolean))].sort()
    },
    estatusDisponibles() {
      return [...new Set((this.armas || []).map((arma) => arma?.CatEstatus?.title).filter(Boolean))].sort()
    },
    armasFiltradas() {
      return (this.armas || []).filter((arma) => {
        const tipoArma = this.normalizarTipoArma(arma?.CatClase?.CatTipo?.title)
        const marca = arma?.CatModelo?.CatMarca?.title || ''
        const estatus = arma?.CatEstatus?.title || ''
        const terminoBusqueda = this.normalizarTexto(this.buscaArma)
        const camposBusqueda = [arma?.CatModelo?.modelo, arma?.folio, arma?.matricula, arma?.noEconomico, arma?.armeros]

        const coincideTipo = this.filtroTipoArma === 'TODOS' || tipoArma === this.filtroTipoArma
        const coincideMarca = !this.marcasSeleccionadas.length || this.marcasSeleccionadas.includes(marca)
        const coincideEstatus = !this.estatusSeleccionados.length || this.estatusSeleccionados.includes(estatus)
        const coincideBusqueda =
          !terminoBusqueda || camposBusqueda.some((campo) => this.normalizarTexto(campo).includes(terminoBusqueda))

        return coincideTipo && coincideMarca && coincideEstatus && coincideBusqueda
      })
    },
  },

  methods: {
    ...mapActions('arma', ['fetchArmas']),
    ...mapActions('claseArma', ['fetchClasesArmaCorta', 'fetchClasesArmaLarga']),
    ...mapActions('modeloArma', ['fetchModeloArmas']),
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapMutations('arma', ['SET_SELECTED_ARMA']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    normalizarTexto(valor) {
      return (valor || '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
    },
    normalizarTipoArma(tipo) {
      const tipoNormalizado = this.normalizarTexto(tipo)

      if (tipoNormalizado.includes('corta')) return 'CORTA'
      if (tipoNormalizado.includes('larga')) return 'LARGA'

      return ''
    },
    openEstatusArmaDialog(arma) {
      this.SET_SELECTED_ARMA(arma)
      this.SET_DIALOG(DIALOG_TYPES.ESTATUS_ARMA_DIALOG_COMPONENT)
    },

    async openEditarArmaDialog(arma) {
      this.loadingEditarArma = arma.idArma
      await Promise.all([
        this.fetchClasesArmaCorta(),
        this.fetchClasesArmaLarga(),
        this.fetchModeloArmas(arma.CatModelo?.fk_idMarca),
      ])
      this.loadingEditarArma = false
      this.SET_SELECTED_ARMA(arma)
      this.SET_DIALOG(this.DIALOG_TYPES.EDITAR_ARMA_DIALOG_COMPONENT)
    },
    openRegistroArmaDialog() {
      this.SET_DIALOG(DIALOG_TYPES.RESGITRO_ARMA_NUEVA)
    },

    descargarCsv() {
      const data = this.armasFiltradas.map((arma) => ({
        Tipo: arma?.CatClase?.CatTipo?.title || '',
        Marca: arma?.CatModelo?.CatMarca?.title || '',
        Modelo: arma?.CatModelo?.modelo || '',
        Folio: arma?.folio || '',
        Matricula: arma?.matricula || '',
        'No. economico': arma?.noEconomico || '',
        Armero: arma?.armeros || '',
        'Fecha alta LOC': arma?.fechaAltaLoc || '',
        Estatus: arma?.CatEstatus?.title || '',
      }))
      downloadCsv(data, { filename: 'catalogo-armas' })
    },

    async openHistorialArmasDialog(arma) {
      try {
        this.SET_SELECTED_ARMA(arma)
        await this.$store.dispatch('armeria/fetchHistorialByArma', arma.idArma)
        this.SET_DIALOG({
          ...this.DIALOG_TYPES.HISTORIAL_ARMAS,
          props: {
            idArma: arma.idArma,
          },
        })
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('No fue posible cargar el historial del arma.')
      }
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para InventarioTabContent */
.ui-module-card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

/* Título */
.v-card-title {
  color: #e0e0e0 !important;
  font-weight: 600;
}

/* Tabla de datos */
::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-table-header {
  background: rgba(108, 92, 231, 0.15) !important;
}

::v-deep .v-data-table-header th {
  color: #e0e0e0 !important;
  font-weight: 600 !important;
  border-bottom: 2px solid rgba(108, 92, 231, 0.3) !important;
}

::v-deep .v-data-table tbody tr {
  transition: all 0.3s ease;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(108, 92, 231, 0.1) !important;
  transform: scale(1.01);
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(108, 92, 231, 0.1) !important;
}

::v-deep .v-data-footer {
  background: rgba(18, 18, 18, 0.5) !important;
  border-top: 1px solid rgba(108, 92, 231, 0.2) !important;
  color: #e0e0e0 !important;
}

/* Texto del cuerpo */
.text-body-2 {
  color: #e0e0e0 !important;
}

/* Inputs de filtros y búsqueda */
::v-deep .search-input .v-input__slot,
::v-deep .filter-input .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(108, 92, 231, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .search-input .v-input__slot:hover,
::v-deep .filter-input .v-input__slot:hover {
  border-color: rgba(108, 92, 231, 0.45) !important;
}

::v-deep .search-input .v-input__control,
::v-deep .filter-input .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .search-input.v-input--is-focused .v-input__control,
::v-deep .filter-input.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .search-input .v-input__slot input,
::v-deep .filter-input .v-input__slot input,
::v-deep .filter-input .v-select__selection,
::v-deep .filter-input .mdi-menu-down,
::v-deep .search-input .mdi-magnify {
  color: #e0e0e0 !important;
}

::v-deep .search-input .v-label,
::v-deep .filter-input .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .search-input.v-input--is-focused .v-label,
::v-deep .filter-input.v-input--is-focused .v-label {
  color: #a29bfe !important;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px;
  text-transform: none;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

::v-deep .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(108, 92, 231, 0.3);
}

/* Iconos */
::v-deep .v-icon {
  color: #e0e0e0;
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  color: #6c5ce7 !important;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(30, 30, 46, 0.95) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(108, 92, 231, 0.3);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  padding: 8px 12px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #e0e0e0 !important;
}

/* ==================== SCROLLBAR ==================== */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(108, 92, 231, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(108, 92, 231, 0.6);
}

/* ==================== BOTONES CON RIPPLE ==================== */
::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}
</style>
